import { ElementRef, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  scrollToFirstInvalidControl(elRef: ElementRef): void {
    const firstInvalidControl: HTMLElement = elRef.nativeElement.querySelector('.ng-invalid:not(form)');
    if (firstInvalidControl) {
      setTimeout(
        () =>
          firstInvalidControl.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          }),
        200,
      );
    }
  }

  scrollToFirstControl(elementRef: ElementRef<HTMLElement>): void {
    const firstInvalidControl = elementRef.nativeElement.querySelector('portal-ui-expand[ng-reflect-state="edit"]');
    if (firstInvalidControl) {
      setTimeout(() => {
        firstInvalidControl?.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
        });
      }, 200);
    }
  }
}
